module.exports = __webpack_public_path__ + "static/media/h5_game_header_bg.a5408b56.png";